(function() {
  'use strict';

  var MAX_RETRIES    = 10;
  var SWEEP_INTERVAL = 1000; // poll every 1s
  var MAX_SWEEPS     = 30;   // give up after ~30s of polling

  var sweepTimer = null;
  var sweepCount = 0;

  function sweep() {
    var anyPending = false;

    document.querySelectorAll('img[data-tee-image]').forEach(function(img) {
      if (img.dataset.teeLoaded === 'true') return;

      if (img.complete) {
        if (img.naturalWidth > 0) {
          // Loaded successfully
          img.dataset.teeLoaded = 'true';
          img.classList.add('tee-loaded');
          return;
        }
        if (img.src) {
          // Failed — retry with cache-buster on the base URL
          var r = parseInt(img.dataset.teeRetries) || 0;
          if (r >= MAX_RETRIES) return;
          r++; img.dataset.teeRetries = r;
          var base = (img.dataset.teeSrc || img.src).split('?')[0];
          img.src = base + '?_t=' + Date.now();
          anyPending = true;
          return;
        }
      }

      // Still loading (not complete) — wait for next sweep
      anyPending = true;
    });

    return anyPending;
  }

  function startSweeping() {
    stopSweeping();
    sweepCount = 0;
    sweepTimer = setInterval(function() {
      sweepCount++;
      var pending = sweep();
      if (!pending || sweepCount >= MAX_SWEEPS) stopSweeping();
    }, SWEEP_INTERVAL);
  }

  function stopSweeping() {
    if (sweepTimer) { clearInterval(sweepTimer); sweepTimer = null; }
  }

  function hydrate() {
    sweep();         // immediate pass
    startSweeping(); // then poll
  }

  // Expose for direct calls from cart-drawer.js / cart.js after renderContents()
  window.TeeCartImageLoader = { hydrate: hydrate };

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function() { setTimeout(hydrate, 150); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hydrate);
  else hydrate();
})();
